export default "__VITE_ASSET__DpLRr0d4__"